var _circle, _path, _rect, _ellipse, _path2, _path3, _rect2, _rect3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "white",
    stroke: "#90205D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5996 14.1262C19.5996 12.5933 20.8423 11.3506 22.3752 11.3506H25.817C27.3499 11.3506 28.5926 12.5933 28.5926 14.1262H19.5996Z",
    fill: "url(#paint0_linear_3690_8894)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.9121,
    y: 8.21289,
    width: 0.615955,
    height: 3.37895,
    fill: "url(#paint1_linear_3690_8894)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2193,
    cy: 7.18703,
    rx: 1.29351,
    ry: 1.26711,
    fill: "url(#paint2_linear_3690_8894)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1787 36.6406C11.2661 36.632 8.98352 32.4785 8.33086 30.4006C7.51419 30.4006 5.88086 30.0166 5.88086 28.4806V23.2006C6.04363 22.5628 6.95256 21.3848 9.28657 21.7567C10.518 17.7446 14.4238 13.1652 24.01 13.5755C33.5937 13.1667 37.4983 17.746 38.7293 21.7576C41.0676 21.3828 41.978 22.5623 42.1409 23.2006V28.4806C42.1409 30.0166 40.5075 30.4006 39.6909 30.4006C39.0375 32.4806 36.7509 36.6406 32.8309 36.6406H15.1787Z",
    fill: "url(#paint3_linear_3690_8894)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3209 36.6406H15.1909C11.2709 36.6406 8.98419 32.4806 8.33086 30.4006C7.51419 30.4006 5.88086 30.0166 5.88086 28.4806V23.2006C6.04419 22.5606 6.95886 21.3766 9.31086 21.7606M14.7009 36.6406H32.8309C36.7509 36.6406 39.0375 32.4806 39.6909 30.4006C40.5075 30.4006 42.1409 30.0166 42.1409 28.4806V23.2006C41.9775 22.5606 41.0629 21.3766 38.7109 21.7606M8.82117 25.1204C8.65783 20.9604 11.5649 12.8326 24.5009 13.6006M39.1945 25.1206C39.3578 20.9606 36.4508 12.8328 23.5148 13.6008",
    stroke: "url(#paint4_linear_3690_8894)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7402,
    y: 19.3604,
    width: 22.54,
    height: 11.52,
    rx: 5.76,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7402,
    y: 19.3604,
    width: 22.54,
    height: 11.52,
    rx: 5.76,
    stroke: "url(#paint5_linear_3690_8894)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3599 25.6002C31.3599 26.3954 30.7018 27.0402 29.8899 27.0402C29.0781 27.0402 28.4199 26.3954 28.4199 25.6002C28.4199 24.8049 29.0781 24.1602 29.8899 24.1602C30.7018 24.1602 31.3599 24.8049 31.3599 25.6002Z",
    fill: "url(#paint6_linear_3690_8894)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6002 25.6002C19.6002 26.3954 18.942 27.0402 18.1302 27.0402C17.3183 27.0402 16.6602 26.3954 16.6602 25.6002C16.6602 24.8049 17.3183 24.1602 18.1302 24.1602C18.942 24.1602 19.6002 24.8049 19.6002 25.6002Z",
    fill: "url(#paint7_linear_3690_8894)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3690_8894",
    x1: 18.1296,
    y1: 12.9741,
    x2: 20.0823,
    y2: 16.4084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3690_8894",
    x1: 23.8114,
    y1: 10.1894,
    x2: 24.3536,
    y2: 10.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3690_8894",
    x1: 22.5029,
    y1: 7.4023,
    x2: 24.262,
    y2: 8.37705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3690_8894",
    x1: -0.0462566,
    y1: 27.0567,
    x2: 18.6188,
    y2: 42.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3690_8894",
    x1: -0.0462566,
    y1: 27.0567,
    x2: 18.6188,
    y2: 42.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3690_8894",
    x1: 9.05581,
    y1: 26.0989,
    x2: 18.4698,
    y2: 36.0971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3690_8894",
    x1: 27.9393,
    y1: 25.8448,
    x2: 29.9385,
    y2: 26.9525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3690_8894",
    x1: 16.1796,
    y1: 25.8448,
    x2: 18.1787,
    y2: 26.9525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackLogo);
export default __webpack_public_path__ + "static/media/feedbackLogo.de49ba97.svg";
export { ForwardRef as ReactComponent };